export const ANNOUNCEMENT_TEMPLATES = [
    (routine) => `Number ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Coming to the stage, routine number ${routine.routineNumber}! This ${routine.ageGroup} ${routine.division} ${routine.category} is titled..... ${routine.routineName}!`,
    
    (routine) => `Please welcome routine ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Up next is number ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Routine number ${routine.routineNumber} takes the stage! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Next to perform, number ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Taking center stage, routine ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Now presenting number ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `Let's welcome routine number ${routine.routineNumber} to the stage! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`,
    
    (routine) => `And now, routine ${routine.routineNumber}! A ${routine.ageGroup} ${routine.division} ${routine.category}! ..... ${routine.routineName}!`
  ];
  
  export const getRandomAnnouncement = (routine) => {
    return ANNOUNCEMENT_TEMPLATES[Math.floor(Math.random() * ANNOUNCEMENT_TEMPLATES.length)](routine);
  };